import React from 'react';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useFooterContext } from 'Context/FooterContext';
import BaseFormLayout from 'Components/ComponentLibrary/Templates/Unauthenticated/Content/BaseFormLayout';
import Portal from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Portal';
import BackToLoginButtonPicker from './BackToLoginButtonPicker';

const PasswordResetEmailFormLayout = () => {
  const { onSubmit, unsourcedErrors, resource } = useMetaLayoutContext();
  const { footerRef } = useFooterContext();
  const { displaySuccess } = useSnackbarContext();

  const sendPasswordResetInstructions = async event => {
    if (event) {
      event.preventDefault();
    }
    try {
      const [res] = await onSubmit();
      displaySuccess(res.attr('message'));
    } catch (e) {
      displaySuccess('Error please refresh and try again');
    }
  };

  return (
    <BaseFormLayout
      onSubmit={event => sendPasswordResetInstructions(event)}
      id={'authentication-password-reset-form'}
      title={'Password Reset'}
      subtitle={'Enter the email associated with your Facet account.'}
      errors={unsourcedErrors}
      message={resource.attr('message')}
    >
      <MetaField
        attr={'address'}
        inputProps={{
          test: 'authentication-reset-password-email-input',
        }}
      />

      <Portal container={footerRef.current}>
        <RoundedButton
          type={'submit'}
          form={'authentication-password-reset-form'}
          onClick={sendPasswordResetInstructions}
          fullWidth
          test={'authentication-send-password-reset-button'}
        >
          {'Send Instructions'}
        </RoundedButton>
        <BackToLoginButtonPicker />
      </Portal>
    </BaseFormLayout>
  );
};

export default PasswordResetEmailFormLayout;
